import React from 'react';
import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/Blog.css';

// Import images
import heroImage from '../img/DF picture.jpg';
import blogImage1 from '../img/Meron & Kids.jpg';
import blogImage2 from '../img/Sweet little girl.jpg';
import blogImage3 from '../img/Meron & Kids.jpg';
import blogImage4 from '../img/volenter1.jpg';

import { Link } from 'react-router-dom';

const Blog = () => {
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
      },
    },
    hover: {
      scale: 1.02,
      transition: { duration: 0.3 }
    }
  };

  const fadeIn = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.8 },
    },
  };

  const pulse = {
    scale: [1, 1.05, 1],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut"
    }
  };

  // Blog posts data
  const blogPosts = [
    {
      id: 1,
      category: "Food Aid",
      title: "Sustaining Communities Through Food Distribution",
      date: "March 15, 2023",
      content: "Our general food distribution program has reached 5,000 vulnerable persons (1,000 families) in Northern Ethiopia. Each family receives 5kg protein, 5 litres of edible oil, and 50kg wheat flour monthly.",
      image: blogImage1,
      link: "#"
    },
    {
      id: 2,
      category: "Health & Hygiene",
      title: "Restoring Dignity Through Sanitary Kits",
      date: "April 2, 2023",
      content: "We've provided dignity/sanitary and hygienic kits for 15,000 displaced women in shelters. The kits include essential items to help women maintain hygiene and dignity during these challenging times.",
      image: blogImage2,
      link: "#"
    },
    {
      id: 3,
      category: "Shelter",
      title: "Providing Basic Shelter for Displaced Families",
      date: "May 10, 2023",
      content: "Our shelter program has distributed 10,000 blankets, plastic sheeting, and family feeding & cooking sets to 5,000 families affected by conflict and drought in the region.",
      image: blogImage3,
      link: "#"
    },
    {
      id: 4,
      category: "Mental Health",
      title: "Healing Trauma Through Counseling",
      date: "June 22, 2023",
      content: "We've trained 40 counselors and 4 supervisors to provide psychological support for 500 targeted persons, including abused women, girls, and children to help them recover emotionally from their experiences.",
      image: blogImage4,
      link: "#"
    }
  ];

  return (
    <div className="blog-page">
      {/* Hero Header */}
      <motion.section 
        className="blog-hero-header"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="blog-hero-overlay"></div>
        <motion.img 
          src={heroImage} 
          alt="Humanitarian work in Ethiopia" 
          className="hero-image"
          initial={{ scale: 1.1 }}
          animate={{ scale: 1 }}
          transition={{ duration: 8, ease: "linear" }}
        />
        <motion.div 
          className="blog-hero-content"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          <motion.h1
            animate={{ 
              textShadow: ["0 0 8px rgba(255,0,0,0.5)", "0 0 12px rgba(255,255,255,0.8)", "0 0 8px rgba(255,0,0,0.5)"]
            }}
            transition={{ 
              duration: 3,
              repeat: Infinity,
              repeatType: "reverse"
            }}
          >
            You're the Hope of Others
          </motion.h1>
          <motion.p
            animate={{ 
              textShadow: ["0 0 4px rgba(255,255,255,0.3)", "0 0 8px rgba(255,255,255,0.6)", "0 0 4px rgba(255,255,255,0.3)"]
            }}
            transition={{ 
              duration: 4,
              repeat: Infinity,
              repeatType: "reverse"
            }}
          >
            Every small contribution makes a big difference in the lives of those we serve.
          </motion.p>
          <motion.div
            animate={pulse}
            className="scroll-indicator"
          >
            <span>↓</span>
          </motion.div>
        </motion.div>
      </motion.section>

      {/* Floating Stats Section */}
      <motion.section 
        className="floating-stats py-4"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div className="container">
          <div className="row g-4">
            <motion.div 
              className="col-md-3 col-6"
              whileHover={{ y: -5 }}
            >
              <div className="stat-card bg-red text-white">
                <h3>5,000+</h3>
                <p>People Fed</p>
              </div>
            </motion.div>
            <motion.div 
              className="col-md-3 col-6"
              whileHover={{ y: -5 }}
            >
              <div className="stat-card bg-black text-white">
                <h3>15,000</h3>
                <p>Hygiene Kits</p>
              </div>
            </motion.div>
            <motion.div 
              className="col-md-3 col-6"
              whileHover={{ y: -5 }}
            >
              <div className="stat-card bg-red text-white">
                <h3>10,000</h3>
                <p>Shelter Items</p>
              </div>
            </motion.div>
            <motion.div 
              className="col-md-3 col-6"
              whileHover={{ y: -5 }}
            >
              <div className="stat-card bg-black text-white">
                <h3>500</h3>
                <p>Counseling Sessions</p>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* Blog Section */}
      <section className="py-5 blog-main-section">
        <div className="container">
          <motion.div 
            className="row justify-content-center text-center mb-4 mb-md-5"
            variants={fadeIn}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <div className="col-xl-9 col-xxl-8">
              <motion.span 
                className="section-badge"
                animate={{
                  backgroundColor: ['#e63946', '#1a1a1a'],
                  color: ['#fff', '#fff']
                }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  repeatType: "reverse"
                }}
              >
                Stories of Impact
              </motion.span>
              <h2 className="display-5 fw-bold text-black">Our Humanitarian Work</h2>
              <motion.p 
                className="lead"
                whileInView={{
                  opacity: 1,
                  y: 0
                }}
                initial={{
                  opacity: 0,
                  y: 20
                }}
                transition={{
                  delay: 0.3
                }}
              >
                22.6 million people in Ethiopia are food insecure due to drought, conflict and rising food prices. 
                These are their stories and how your support is making a difference.
              </motion.p>
            </div>
          </motion.div>

          {/* Blog Posts */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {blogPosts.map((post, index) => (
              <motion.div 
                key={post.id}
                className={`row g-0 align-items-center blog-post ${index % 2 === 0 ? '' : 'flex-md-row-reverse'}`}
                variants={itemVariants}
                whileHover="hover"
              >
                <div className="col-md-6">
                  <motion.div 
                    className="blog-image-container"
                    variants={itemVariants}
                  >
                    <img alt={post.title} className="img-fluid" src={post.image} />
                    <motion.div 
                      className="category-badge"
                      animate={{
                        backgroundColor: ['#e63946', '#1a1a1a'],
                      }}
                      transition={{
                        duration: 3,
                        repeat: Infinity,
                        repeatType: "reverse"
                      }}
                    >
                      {post.category}
                    </motion.div>
                  </motion.div>
                </div>
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-lg-12 col-xxl-10 col-xl-12">
                      <div className="p-md-3 p-xl-5 mt-4 mt-md-0">
                        <motion.div
                          whileHover={{ x: 5 }}
                        >
                          <a className="text-primary fw-semibold text-decoration-none" href={post.link}>
                            {post.category}
                          </a>
                        </motion.div>
                        <motion.h2 
                          className="fw-semibold my-1 text-black"
                          whileHover={{ color: '#e63946' }}
                        >
                          {post.title}
                        </motion.h2>
                        <div className="text-muted">
                          {post.date}
                        </div>
                        <p className="my-4">{post.content}</p>
                        <motion.a 
                          className="btn btn-primary" 
                          href={post.link}
                          whileHover={{ 
                            scale: 1.05,
                            backgroundColor: '#1a1a1a',
                            borderColor: '#1a1a1a'
                          }}
                          whileTap={{ scale: 0.95 }}
                        >
                          Read more
                        </motion.a>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Call to Action */}
      <motion.section 
        className="cta-section py-5 text-center"
        initial="hidden"
        whileInView="visible"
        variants={fadeIn}
        viewport={{ once: true }}
      >
        <div className="cta-overlay"></div>
        <div className="container position-relative">
          <motion.h2 
            className="display-4 fw-bold mb-4 text-white"
            animate={{
              textShadow: ["0 0 8px rgba(255,255,255,0.3)", "0 0 12px rgba(255,255,255,0.6)", "0 0 8px rgba(255,255,255,0.3)"]
            }}
            transition={{ 
              duration: 3,
              repeat: Infinity,
              repeatType: "reverse"
            }}
          >
            Be Part of the Change
          </motion.h2>
          <motion.p 
            className="lead mb-5 text-white"
            animate={{
              textShadow: ["0 0 4px rgba(0,0,0,0.3)", "0 0 8px rgba(0,0,0,0.6)", "0 0 4px rgba(0,0,0,0.3)"]
            }}
            transition={{ 
              duration: 4,
              repeat: Infinity,
              repeatType: "reverse"
            }}
          >
            Join us in our mission to bring hope and change to vulnerable communities in Ethiopia.
          </motion.p>
          <motion.button 
            className="btn btn-danger btn-lg px-5 py-3"
            whileHover={{ 
              scale: 1.05,
              backgroundColor: '#1a1a1a',
              borderColor: '#1a1a1a'
            }}
            whileTap={{ scale: 0.95 }}
            animate={{
              boxShadow: ["0 0 10px rgba(255,255,255,0.3)", "0 0 20px rgba(255,255,255,0.6)", "0 0 10px rgba(255,255,255,0.3)"]
            }}
            transition={{ 
              duration: 2,
              repeat: Infinity,
              repeatType: "reverse"
            }}
          >
             <Link to="/donate-now"className="dd">
            Donate Now
            </Link>
          </motion.button>
        </div>
      </motion.section>

      {/* Floating Action Button */}
      <motion.div
        className="floating-action-btn"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        animate={{
          backgroundColor: ['#e63946', '#1a1a1a'],
          boxShadow: ['0 0 15px rgba(230,57,70,0.7)', '0 0 15px rgba(26,26,26,0.7)']
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      >
        <span>Help Now</span>
      </motion.div>
    </div>
  );
};

export default Blog;